import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  getHistoryIndex,
  getNavigationBack,
  pushNavigationUrl,
} from "@app/shared/lib/navigation-history";

export function useNavigationHistory() {
  const location = useLocation();

  useEffect(() => {
    pushNavigationUrl(
      `${location.pathname}${location.search}`,
      getHistoryIndex(),
    );
  }, [location]);
}

export function useBackNavigation(fallback = "/") {
  const navigate = useNavigate();

  return useCallback(() => {
    const currentUrl = `${window.location.pathname}${window.location.search}`;
    const back = getNavigationBack(currentUrl, getHistoryIndex(), fallback);
    if (back.delta < 0) navigate(back.delta);
    else navigate(back.url);
  }, [fallback, navigate]);
}
